import Container from '../../../elements/Container'
import LazyImage from '../../../elements/LazyImage'
import styles from './styles.module.scss'
import { getS3Url } from '../../../helpers/getS3Url'
import { useResponsive } from '../../../../providers/ResponsiveContext'

const ThreeImages = ({ content }) => {
  const { isDesktop } = useResponsive()

  return (
    <Container variant={['-xs', isDesktop && '-p0']}>
      <div className={styles.grid}>
        <div className={styles.grid__item}>
          <LazyImage
            layout="fill"
            sizes="(min-width: 1250px) 590px, (max-width: 1250px) 70vw, 70vw"
            objectFit="cover"
            objectPosition="center"
            src={getS3Url(
              content.data.cloudflare_image_one || content.data.image_one,
              '1980'
            )}
          />
        </div>
        <div className={styles.grid__item}>
          <LazyImage
            objectFit="cover"
            objectPosition="center"
            sizes="(min-width: 1250px) 390px, (max-width: 1250px) 33vw, 70vw"
            src={getS3Url(
              content.data.cloudflare_image_two || content.data.image_two,
              '960'
            )}
            layout="fill"
          />
        </div>

        <div className={styles.grid__item}>
          <LazyImage
            objectFit="cover"
            objectPosition="center"
            src={getS3Url(
              content.data.cloudflare_image_three || content.data.image_three,
              '960'
            )}
            layout="fill"
          />
        </div>
      </div>
    </Container>
  )
}

export default ThreeImages
